export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref10922.edbe81b8.jpg";